export const SunsetIcon = () => (
  <span role="img" aria-label="sunset" className="anticon anticon-sunset">
    <svg
      viewBox="0 0 12 12"
      focusable="false"
      data-icon="sunset"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 2.5V1H6.5V2.5H5.5ZM2.46445 4.17155L1.40395 3.11105L2.11105 2.40395L3.17155 3.46445L2.46445 4.17155ZM8.82845 3.46445L9.88895 2.40395L10.5961 3.11105L9.53555 4.17155L8.82845 3.46445ZM5.99993 4.5C5.56106 4.49994 5.1299 4.61541 4.74981 4.8348C4.36971 5.0542 4.05406 5.36979 3.8346 5.74985C3.61514 6.12991 3.49959 6.56104 3.49958 6.99991C3.49956 7.34508 3.57102 7.68547 3.70829 8H8.29171C8.42898 7.68548 8.50044 7.34508 8.50042 6.99991C8.50041 6.56104 8.38486 6.12991 8.1654 5.74985C7.94594 5.36979 7.63029 5.0542 7.25019 4.8348C6.8701 4.61541 6.4388 4.49994 5.99993 4.5ZM5.99993 3.5C6.6143 3.49994 7.21801 3.6616 7.7501 3.96873C8.28224 4.27588 8.72414 4.7177 9.03139 5.24979C9.33864 5.78187 9.5004 6.38546 9.50042 6.99988C9.50045 7.6143 9.33872 8.2179 9.03151 8.75L8.88718 9H3.11282L2.96849 8.75C2.66128 8.2179 2.49955 7.6143 2.49958 6.99988C2.4996 6.38546 2.66136 5.78187 2.96861 5.24979C3.27586 4.7177 3.71776 4.27588 4.2499 3.96873C4.78199 3.6616 5.38556 3.49994 5.99993 3.5ZM1.5 7.5H0V6.5H1.5V7.5ZM12 7.5H10.5V6.5H12V7.5ZM12 10V11H0V10H12Z"
      />
    </svg>
  </span>
);
